module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-463faf8e.png";